import { Igoods, ICartItem } from '@/pages/goods/type';
import actionType from '../actions/peripheral/actionType';

interface IBuyway {
  recNo: string;
  resvNo: string;
  roomId: number;
  roomNo: string;
  saleType: 0 | 1; // 销售方式 0前台房间消费，1前台直售
}

interface StaffState {
  // storageType: 1 | 2; // 配置仓库类型1-门店仓、2-前台仓
  // getStorageTypeLoading: boolean;

  saleGoodsList: Array<Igoods>;
  saleGoodsListCopy: Array<Igoods>;
  saleGoodsLoading: boolean;

  searchParam: { categoryId: string; skuName: string };

  cartList: Map<string, ICartItem> | null;
  cartTotalNum: number;
  cartTotalTimes: number;

  clientList: any;
  clientListLoading: boolean;

  buyWay: IBuyway;

  settleLoading: boolean;
  settleGoodsList: any[];
  settleTotalCount: number;
  settleTotalActualPrice: number;
  settleTotalTimeCount: number;
  orderDetail: any;

  actualPay: number;
  financialNotes: string;
}

const initialState: StaffState = {
  // storageType: 2,
  // getStorageTypeLoading: false,

  saleGoodsList: [],
  saleGoodsListCopy: [], // 原始商品列表数据
  saleGoodsLoading: false,

  searchParam: { categoryId: '', skuName: '' },

  cartList: new Map(), // 以列表数据的skuCode为key
  cartTotalNum: 0,
  cartTotalTimes: 0,

  clientList: [],
  clientListLoading: false,

  buyWay: {
    recNo: '',
    resvNo: '',
    roomId: 0,
    roomNo: '',
    saleType: 0, // 销售方式 0前台房间消费，1前台直售
  },

  settleLoading: false,
  settleGoodsList: [],
  settleTotalCount: 0,
  settleTotalActualPrice: 0,
  settleTotalTimeCount: 0,
  orderDetail: {},

  actualPay: 0, // 实际支付
  financialNotes: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.INIT_STATE:
      return {
        // storageType: 2,
        // getStorageTypeLoading: false,

        saleGoodsList: [],
        saleGoodsListCopy: [], // 原始商品列表数据
        saleGoodsLoading: false,

        searchParam: { categoryId: '', skuName: '' },

        cartList: new Map(), // 以列表数据的skuCode为key
        cartTotalNum: 0,
        cartTotalTimes: 0,

        clientList: [],
        clientListLoading: false,

        buyWay: {
          recNo: '',
          resvNo: '',
          roomId: 0,
          roomNo: '',
          saleType: 0, // 销售方式 0前台房间消费，1前台直售
        },

        settleLoading: false,
        settleGoodsList: [],
        settleTotalCount: 0,
        settleTotalActualPrice: 0,
        settleTotalTimeCount: 0,
        orderDetail: {},

        actualPay: 0, // 实际支付
        financialNotes: '',
      };
    case actionType.UPDATE_GOODS_STATE:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.GOODS_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.GET_STORAGE_CONFIG:
      return {
        ...state,
        ...action.payload,
      };
    // 更新搜索内容
    case actionType.UPDATE_SEARCH_PARAM:
      return {
        ...state,
        searchParam: {
          ...state.searchParam,
          [action.payload.field]: action.payload.value,
        },
      };
    case actionType.ADD_GOODS_TO_CART:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.CLIENT_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.UPDATE_BUY_WAY:
      return {
        ...state,
        buyWay: {
          ...state.buyWay,
          ...action.payload,
        },
      };
    default:
      return {
        ...state,
        ...action.payload,
      };
  }
};
